module.exports = __webpack_public_path__ + "static/media/default_picture_RM.0abb47bb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/default_picture_RM.jpg
// module id = 63
// module chunks = 0